/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AnalysisSectionTitle/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import * as fromHelpers from './helpers.js'
import PenIcon from 'DesignSystem/Svgs/PenIcon/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import XrayIcon from 'DesignSystem/Svgs/XrayIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function AnalysisSectionTitle({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CephTracing/ViewTraces/Content/AnalysesTree/Analyses/Content/Analysis/AnalysisSectionTitle"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let requestUpdatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'request',
path: 'updated_at',
format: fromFormat.dateISOToDateAndTime,
})
let constantData = '-'
let requestAudaxAnalysisTypeNameValueData = fromData.useDataFormat({ viewPath,
context: 'request',
path: 'audax_analysis_type_name',
format: fromHelpers.truncateTitle,
})
let aggregateData = fromAggregate.join(requestUpdatedAtValueData, constantData, requestAudaxAnalysisTypeNameValueData)
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="AnalysisSectionTitle.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<XrayIcon
  viewPath={`${viewPath}/XrayIcon`}
 width={dtSpaceM}
 height={dtSpaceM}
/>
<button
  data-testid="AnalysisSectionTitle.Vertical"
  data-view-path={viewPath}
 onClick={flow.has(fromFlow.normalizePath(viewPath, '../Content/No')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, '../Content/Content')) : () => setFlowTo(fromFlow.normalizePath(viewPath, '../Content/No'))}
 style={{'--ml-1-Z1LpKeQ': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 data="request.updated_at"
 format="/Data/format.js dateISOToDateAndTime"
 data={aggregateData}
 data="'-'"
 data="request.audax_analysis_type_name"
 aggregate="/Data/aggregate.js join"
 format="helpers.js truncateTitle"
 text={aggregateData}
/>
</button>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 onClick={onClick}
 size="small"
 type="secondary"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<PenIcon
{...childProps}
  viewPath={`${viewPath}/PenIcon`}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
</div>
{children}
</React.Fragment>)
}